import {
  callCenterSimBoundStatus,
  initCallDeviceInfo,
  syncRoundCallStatus
} from '@/apis/callCenter/turnCall'
import {
  callCenterStatusEnum,
  seatStatusEnum,
  dacoMsg,
  dialingScenes,
  callResult,
  CallingCode,
  callDirection
} from '@/enums/callCenter'
import { useCallCenter } from '@/stores/modules/callCenter'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { ref } from 'vue'
import { useTurnCall } from '@/hooks/callCenter/turnCall'
import {
  cacheUserIdAndCustId,
  callCenterHangUp,
  callCenterLinkInfo,
  generateCallId,
  releaseGlobalDialLock
} from '@/apis/callCenter/callCenter'
import { useAccountStore } from '@/stores/modules/account'
import { useCall } from './call'
import type { CallUserInfoVO } from '@/types/callCenter/callCenter'
import { rxkMessageBox } from '@/components/common/RxkMessageBox'
import { cloneDeep } from '@/utils/tools'
import { useCallScreen } from '@/components/business/callCenter/callScreen/src/hooks/useCallScreen'
import MyGlobalEvent from '@/utils/bus/baseBus'
import { router } from '@/router'

/**
 * 多卡话机
 */
const Socket = ref()
const setIntervalWesocketPush = ref()
const times = ref(0)
const callCenter = ref()
const turnCall = ref()
const call = ref()
const changeNum = ref(0)

export function useDaco() {
  const { userInfo } = useAccountStore()

  // 建立连接
  function createCallCenterSocket() {
    callCenter.value = useCallCenter()
    turnCall.value = useTurnCall()
    call.value = useCall()
    const WSS_URL = 'ws://127.0.0.1:8800/' // websocket 连接地址带参数
    Socket.value = new WebSocket(WSS_URL)
    console.log(Socket, '呼叫中心')
    Socket.value.onopen = onopenWS
    Socket.value.onmessage = onmessageWS
    Socket.value.onerror = onerrorWS
    Socket.value.onclose = oncloseWS
  }

  /** 打开WS之后发送心跳 */
  function onopenWS() {
    sendPing() // 发送心跳
  }
  /** 发送心跳 */
  function sendPing() {
    sendWSPush(JSON.stringify(dacoMsg.link))
    setIntervalWesocketPush.value = setInterval(() => {
      Socket.value.send('ping')
    }, 300000)
  }

  /** 发送消息
   * @param eventType
   */
  function sendWSPush(data: any) {
    console.log(Socket.value, '发送消息')
    if (Socket.value !== null && Socket.value.readyState === 3) {
      Socket.value.close()
      createCallCenterSocket() // 重连
    } else if (Socket.value.readyState === 1) {
      Socket.value.send(data)
    } else if (Socket.value.readyState === 0) {
      setTimeout(() => {
        Socket.value.send(data)
      }, 3000)
    }
    console.log('数据已发送', data)
  }
  /** 连接失败重连/关闭 */
  function onerrorWS() {
    clearInterval(setIntervalWesocketPush.value)
    if (times.value === 5) {
      Socket.value.close()
      times.value = 0
      return false
    }
    times.value++
    // Socket.close()
    setTimeout(() => {
      createCallCenterSocket() // 重连
    }, 1000)
  }
  /** 关闭WS */
  async function oncloseWS() {
    if (!isNullOrUndefOrEmpty(Socket.value)) {
      clearInterval(setIntervalWesocketPush.value)
      Socket.value.close()
      callCenter.value.setCallSeatStatus(seatStatusEnum.LEAVE)
      callCenter.value.setCallCenterStatus(callCenterStatusEnum.STOP)
      if (
        callCenter.value.dialingScenes === dialingScenes.turnCall ||
        callCenter.value.dialingScenes === dialingScenes.turnCallApp
      ) {
        ElMessage.warning('呼叫服务连接失败，轮呼终止')
        await turnCall.value.shutdown()
      }
    }
  }
  // sim卡号绑定
  function bindPhoneNumber() {
    // 19031228  计算机之父冯·诺依曼诞生
    const msg = `19031228${callCenter.value.iccid}`
    const sedMsg = {
      cmd: 'sendmsg',
      number: callCenter.value?.callCenterConfig?.smsTransitNumber,
      msg: msg
    }
    sendWSPush(JSON.stringify(sedMsg))
  }
  // 设置话机是否脱敏
  function setHidNumber(hidden: boolean) {
    const sedMsg = {
      cmd: 'HIDENUMBER',
      type: 1,
      hidden: +hidden
    }
    sendWSPush(JSON.stringify(sedMsg))
  }

  // 消息监听
  function onmessageWS(e: any) {
    const data = JSON.parse(e.data)
    console.log('接收数据', data)
    switch (data.cmd) {
      case 'LINK':
        // store.dispatch('setLinkStatus', data.success)
        break
      // 成功连接usb
      case 'USB':
        if (data.connected) {
          // 连接成功
          callCenter.value.setCallCenterStatus(callCenterStatusEnum.READY)
          callCenter.value.setUsbStatus(data.connected)
          if (isNullOrUndefOrEmpty(callCenter.value.imei)) {
            // 获取设备IMEI信息 getIMEI
            sendWSPush(JSON.stringify(dacoMsg.getIMEI))
          }
          // 获取iccid
          sendWSPush(JSON.stringify(dacoMsg.getIccid))
        } else {
          // 链接断开/链接失败
          callCenter.value.setUsbStatus(data.connected)
          callCenter.value.setCallCenterStatus(callCenterStatusEnum.STOP)
          // 如果正在轮呼则终止轮呼
          if (callCenter.value.dialingScenes === dialingScenes.turnCall) {
            turnCall.value.shutdown()
          }
          // 通话中挂断电话
          if (callCenter.value.callCenterStatus === callCenterStatusEnum.CALLING) {
            callCenter.value.setShowCallScreen(false)
          }
          ElMessage.error({
            message: '设备已断开，请检查话机连接线',
            type: 'error',
            duration: 5 * 1000
          })
        }
        if (!isNullOrUndefOrEmpty(callCenter.value.imei)) {
          // 初始化话机信息
          initCallDeviceInfo({
            deviceImei: callCenter.value.imei,
            deviceStatus: +data.connected
          })
        }

        // 初始化话机模式为关闭耳机模式1.3.2
        sendWSPush(
          JSON.stringify({
            cmd: 'SETMODE',
            mode: 0
          })
        )
        // 初始化话机不弹窗
        sendWSPush(
          JSON.stringify({
            cmd: 'setShowNotice',
            value: 0
          })
        )
        break
      // 获取IMEI
      case 'READIMEI':
        callCenter.value.setIMEI(data.imei)
        initCallDeviceInfo({
          deviceImei: data.imei,
          deviceStatus: +callCenter.value.usbStatus
        })
        break
      // 获取iccid
      case 'getIccid':
        callCenter.value.setUsbStatus(!isNullOrUndefOrEmpty(data.iccid))
        callCenter.value.setCallCenterStatus(
          !isNullOrUndefOrEmpty(data.iccid) ? callCenterStatusEnum.READY : callCenterStatusEnum.STOP
        )
        callCenter.value.setIccid(data.iccid)
        callCenter.value.setSimList(data.sim)
        if (!isNullOrUndefOrEmpty(data.iccid) && isNullOrUndefOrEmpty(data.number)) {
          // 判断是否已经绑定过电话号码
          callCenterSimBoundStatus({
            iccid: data.iccid
          }).then(res => {
            if (!res) {
              bindPhoneNumber()
            }
          })
        }
        // 存储sim卡号码
        if (!isNullOrUndefOrEmpty(data.number)) {
          // 判断号码是否包含'+86',有则截取
          callCenter.value.setCallerPhone(
            data.number.indexOf('+86') !== -1 ? data.number.slice(3) : data.number
          )
        }
        break
      // 拨打电话
      case 'ATD':
        callCenter.value.setCallResult(callResult.startCall)
        callCenter.value.setCallInResult(callResult.startCall)
        callCenter.value.setCallWriteFollowTag(false)
        if (!data.success) {
          callCenter.value.setCallType(1)
          // 呼叫失败
          callCenter.value.setCallCenterStatus(callCenterStatusEnum.READY)
          // store.dispatch('setCallStatus', '')
          releaseGlobalDialLock() // 释放通话锁
          if (callCenter.value.dialingScenes === dialingScenes.turnCall) {
            turnCall.value.shutdown()
            syncRoundCallStatus({
              id: callCenter.value.callUserInfo.title.roundCustomerId,
              callStatus: callResult.failed
            })
          }
          ElMessage({
            message: '拨打失败',
            type: 'error',
            duration: 5 * 1000
          })
        } else {
          console.log('拨打中')
          callCenter.value.setCallResult(callResult.unConnected)
          callCenter.value.setCallInResult(callResult.unConnected)
          callCenter.value.setCallId(data.callId)
          callCenter.value.setCallCenterStatus(callCenterStatusEnum.CALLING)
          callCenter.value.setCallingCode(CallingCode.CORG)
          callCenter.value.setShowCallScreen(true)
          // store.dispatch('setShowAddCustom', true)
          // store.dispatch('setClickAdd', false)
          // store.dispatch('setRoundCallIn', false)
          // 拨打成功设置多卡话机相关文件参数
          if (callCenter.value.dialingScenes === dialingScenes.turnCall) {
            setRoundCallrecordUrl()
          } else {
            setCallrecordUrl()
          }

          const callUserInfoVO =
            callCenter.value.callDirection === callDirection.out
              ? callCenter.value.callUserInfo
              : callCenter.value.callUserInfoIn
          console.log(callUserInfoVO, '拨打中callUserInfoVOcallUserInfoVO')
          // 自动跳转详情页
          if (!callUserInfoVO.title?.unknow && callUserInfoVO?.userList?.length === 0) {
            if (
              userInfo.id === callUserInfoVO?.title.followUserId ||
              callCenter.value.dialingScenes === dialingScenes.singleCall
            ) {
              // 是cps回访就不跳转
              if (callCenter.value.callType === 2) return
              call.value.jumpToDetail(
                callUserInfoVO?.title?.customerId as string,
                callUserInfoVO?.title?.realName as string
              )
              // if(!['/customerDetail', '/clueDetail'].includes(router.currentRoute.value.path)){
              //   callCenter.value.setShowCallScreen(false)
              // }
            }
          }
        }
        break
      // 接通
      case 'CBEGIN': {
        console.log('接通')
        if (callCenter.value.callDirection === callDirection.out) {
          callCenter.value.setCallResult(callResult.connected)
          callCenter.value.setCallingCode(CallingCode.CBEGIN)
        } else {
          callCenter.value.setCallInResult(callResult.connected)
          callCenter.value.setCallingCode(CallingCode.CBEGIN)
        }
        const useCallScreenHooks = useCallScreen()
        const callUserInfoVO =
          callCenter.value.callDirection === callDirection.out
            ? callCenter.value.callUserInfo
            : callCenter.value.callUserInfoIn
        // 自动新建--排除快速拨号
        if (
          callCenter.value.callUserInfo?.title?.unknow &&
          callCenter.value.dialingScenes !== dialingScenes.quickCall
        ) {
          useCallScreenHooks.callAddCustom(callUserInfoVO)
        }
        break
      }
      // 挂断
      case 'CEND':
        callCenter.value.setCallingCode(CallingCode.CEND)
        // store.state.callCenter.callDirection === 'out' ? store.dispatch('setCallStatus', 'CEND') : store.dispatch('setCallInStatus', 'CEND')
        // console.log(store.state.callCenter.callStatus, '挂断')
        // store.dispatch('setCallResult', store.state.callCenter.callStatus === 'CBEGIN' ? 1 : 2)
        releaseGlobalDialLock() // 释放通话锁
        callCenter.value.setCallWriteFollowTag(false)
        // cps回访呼叫
        if (callCenter.value.callType === 2) {
          // TODO 弹出回访记录框
          callCenter.value.setShowCpsCallRecord(true)
          callCenter.value.setCallType(1)
        }
        callCenterHangUp({
          callType: 1,
          callId: data.callId,
          iccid: callCenter.value.iccid,
          imei: callCenter.value.imei,
          callStatus:
            callCenter.value.callDirection === callDirection.out
              ? callCenter.value.callResult
              : callCenter.value.callInResult
        })
          .then(() => {
            // 挂断后操作
            handleHangUp()
          })
          .catch(() => {
            handleHangUp()
          })
        break
      // 来电
      case 'CALLING':
        // 如果正在轮呼中，且状态为轮呼等待中，终止当前轮呼
        // 设置呼入
        callCenter.value.setCallDirection(callDirection.in)
        callCenter.value.setCallInId(data.callId)
        callCenter.value.setCallInResult(callResult.unConnected)
        callCenter.value.setFloadMenu(false)
        callCenter.value.setCallCenterStatus(callCenterStatusEnum.CALLING)
        callCenter.value.setCallingCode(CallingCode.CORG)
        callCenter.value.setCallType(1)

        if (callCenter.value.dialingScenes === dialingScenes.turnCall) {
          ElMessage.error('设备繁忙，轮呼已停止')
          callCenter.value.setdialingScenes(dialingScenes.dokaCallIn)
          turnCall.value.shutdown()
        } else {
          // 设置场景为呼入
          callCenter.value.setdialingScenes(dialingScenes.dokaCallIn)
        }

        callCenterLinkInfo({
          callerPhone: data.number
        }).then(res => {
          let userInfoVO: CallUserInfoVO = {}
          if (res && res.length > 0) {
            userInfoVO = {
              title: {
                ...res[0],
                unknow: false,
                desensitizePhoneNum: data.number,
                plaintextPhone: data.number
              },
              userList: res,
              gcId: ''
            }
          } else {
            // 无关联客户-未知用户
            userInfoVO = {
              title: {
                plaintextPhone: data.number,
                realName: '未知用户',
                unknow: true,
                desensitizePhoneNum: data.number,
                dataFrom: 1
              },
              userList: [],
              gcId: ''
            }
          }
          callCenter.value.setCallUserInfoIn(userInfoVO)
          getCallNumber()
          callCenter.value.setShowCallScreen(true)
          callCenter.value.setCallingCode(CallingCode.CBEGIN)
          callCenter.value.setCallCenterStatus(callCenterStatusEnum.CALLING)
          // store.dispatch('setCallPhoneUserInfoIn', userInfo).then(res => {
          //   getCallNumber()
          //   // 修改当前通话状态
          //   store.dispatch('setCallInStatus', 'CALLING')
          //   store.dispatch('setCallDialogVisible', true)
          //   store.dispatch('setIsCalling', true)
          //   store.commit('SET_VIEW_SEAT_STATUS', 1)
          // })
          // console.log(store.state.callCenter.callPhoneUserInfoIn, store.state.callCenter.callStatus)
        })
        break
      // 开始切卡
      case 'begChgSim':
        // 手动切卡
        console.log('手动切卡')
        sendWSPush(JSON.stringify(dacoMsg.getIccid))
        // store.dispatch('setChangeSimType', 2)
        break
      // 切卡changeSim
      case 'changeSim':
        console.log(data, 'changeSim')
        // 自动切卡
        if (!data.success) {
          changeNum.value++
          // 继续切卡
          changeSim()
        } else {
          changeNum.value = 0
        }
        break
      // 结束切卡
      case 'endChgSim':
        // 获取iccid
        // store.dispatch('setChangeSimType', 1)
        sendWSPush(JSON.stringify(dacoMsg.getIccid))
        ElMessage.success('切卡成功，请重新发起呼叫')
        break
    }
  }

  async function handleHangUp() {
    const successFn = () => {
      callCenter.value.setShowCallScreen(false)
      callCenter.value.setCallCenterStatus(callCenterStatusEnum.READY)
      callCenter.value.setCallingCode('')
    }
    const useCallScreenHooks = useCallScreen()
    if (
      callCenter.value.dialingScenes === dialingScenes.quickCall ||
      callCenter.value.dialingScenes === dialingScenes.singleCall ||
      callCenter.value.dialingScenes === dialingScenes.dokaCallIn
    ) {
      // 快速呼叫挂断 单呼挂断 来电挂断
      successFn()
      const callUserInfoVO =
        callCenter.value.callDirection === callDirection.out
          ? callCenter.value.callUserInfo
          : callCenter.value.callUserInfoIn

      // 如果没有新建，则弹出新建
      if (
        callCenter.value.dialingScenes === dialingScenes.quickCall &&
        !callCenter.value.quickCallAdd &&
        callUserInfoVO?.userList?.length === 0 &&
        callUserInfoVO?.title?.unknow &&
        callCenter.value.callResult === callResult.connected
      ) {
        useCallScreenHooks.callAddCustom(callUserInfoVO)
      }
    }

    // 轮呼挂断
    if (
      callCenter.value.dialingScenes === dialingScenes.turnCall ||
      callCenter.value.dialingScenes === dialingScenes.turnCallApp
    ) {
      // MyGlobalEvent.$emit('roundCallTableRefresh')
      callCenter.value.setShowCallScreen(false)
      callCenter.value.setCallCenterStatus(callCenterStatusEnum.READY)
      // 更新轮呼客户通话状态
      await syncRoundCallStatus({
        id: callCenter.value.callUserInfo?.title?.roundCustomerId,
        callStatus: callCenter.value.callResult,
        version: 160
      })
      MyGlobalEvent.$emit('roundCallDetailRefresh')
      if (callCenter.value.callResult === callResult.unConnected) {
        // 轮呼时，无论通话是否接通，系统打开详情页后，需手动点击呼叫下一个才弹出等待弹窗，在客户详情页未点击呼叫下一个时不会触发拨打下一个
        if (['/customerDetail', '/clueDetail'].includes(router.currentRoute.value.path)) {
          ElMessage.warning('通话未接通')
          callCenter.value.setFloadMenu(true)
        } else {
          // 未接通，自动轮呼下一个
          ElMessage.warning('通话未接通，即将呼叫下一个')
          turnCall.value.showCountDown()
        }
      }
      if (callCenter.value.callResult === callResult.failed) {
        ElMessage.warning('轮呼已经终止了')
      }
      if (callCenter.value.callResult === callResult.connected) {
        // 已接通，显示悬浮窗
        callCenter.value.setFloadMenu(true)
      }
    }
  }

  /**
   * 打电话生成callNumber
   */
  function getCallNumber() {
    let callNumberIn = 0
    let callNumberOut = 0
    generateCallId(callCenter.value.callDirection === callDirection.in ? 'in' : 'out')
      .then(res => {
        // 存来电与去电的callNumber
        callCenter.value.callDirection === callDirection.in
          ? (callNumberIn = res || 0)
          : (callNumberOut = res || 0)
        // 拨打电话
        getCall(callCenter.value.callDirection === callDirection.in ? callNumberIn : callNumberOut)
      })
      .catch(() => {
        // 拨打电话
        getCall(callCenter.value.callDirection === callDirection.in ? callNumberIn : callNumberOut)
      })
  }
  function getCall(callNumber: string | number) {
    if (callCenter.value.callDirection === callDirection.out) {
      /// 拨打电话
      const callMsg = {
        cmd: 'ATD',
        number: callCenter.value.callUserInfo.title.plaintextPhone,
        callid: callCenter.value.iccid
      }
      callCenter.value.setCallNumberOut(callNumber)
      sendWSPush(JSON.stringify(callMsg))
    } else {
      callCenter.value.setCallNumberIn(callNumber)
      if (callCenter.value.dialingScenes === dialingScenes.turnCall) {
        setRoundCallrecordUrl()
      } else {
        setCallrecordUrl()
      }
    }
  }

  function setCallrecordUrl(type = 'cache') {
    const uniqueId =
      callCenter.value.callDirection === callDirection.in
        ? callCenter.value.callInId
        : callCenter.value.callId
    const userInfoVO =
      callCenter.value.callDirection === callDirection.in
        ? callCenter.value.callUserInfoIn
        : callCenter.value.callUserInfo
    console.log(callCenter.value, 'setCallrecordUrl')
    let customId: string | number = 0
    if (userInfoVO?.userList?.length > 0) {
      customId = 0 // 多用户
    } else {
      if (userInfoVO?.title?.unknow) {
        customId = 0 // 未知用户
      } else {
        customId = userInfoVO?.title?.objectId
        const { bizType } = userInfoVO?.title || {}
        const isExt = Number(bizType) === 3 ? 'EXT' : ''
        customId = `AD${customId}${isExt}`
      }
    }

    const cacheParams = {
      customId,
      uniqueId,
      dialScene: 2
    }
    if (type === 'save') {
      cacheUserSave(cacheParams)
    } else {
      cacheUser(cacheParams)
    }
  }

  // 轮呼设置通话记录 HD
  function setRoundCallrecordUrl(type = 'cache') {
    const { roundCustomerId = 0 } = callCenter.value.callUserInfo.title
    const customId = `HD${roundCustomerId}`
    const data = {
      customId,
      uniqueId: callCenter.value.callId,
      dialScene: 1
    }
    type === 'save' ? cacheUserSave(data) : cacheUser(data)
  }

  // 用于新建客户
  async function cacheUserSave(data: Recordable) {
    let currentUserInfo = userInfo
    if (!currentUserInfo.id) {
      // 线上出现了200ubndefined的情况，补救这种情况
      await useAccountStore?.()?.getUser?.()
      currentUserInfo = useAccountStore()?.userInfo
    }
    const {
      callCenterConfig,
      callNumberIn,
      callNumberOut,
      iccid,
      callUserInfo,
      callPhoneUserInfoIn
    } = callCenter.value
    const userInfoVO =
      callCenter.value.callDirection === callDirection.in ? callPhoneUserInfoIn : callUserInfo
    // let callNumber = ''
    // if(callCenter.value.dialingScenes === dialingScenes.dokaRoundCallIn || callCenter.value.callDirection === callDirection.out) {
    //   callNumber = callNumberOut
    // } else {
    //   callNumber = callNumberIn
    // }
    await cacheUserIdAndCustId({
      userId: `200${currentUserInfo.id}`,
      custId: data.customId,
      uniqueId: data.uniqueId,
      parentAppId: callCenterConfig.callCenterAppId,
      iccId: iccid || 0,
      agentId: callCenterConfig.callSeatId,
      callNumber:
        callCenter.value.callDirection === callDirection.in ? callNumberIn : callNumberOut,
      dialScene: data.dialScene,
      objectId: userInfoVO?.title?.objectId,
      callType: callCenter.value.callType
    })
    const sendMsg = {
      cmd: 'setCallrecord',
      pid: callCenterConfig.callCenterAppId,
      callrecordUrl: callCenterConfig.callRecordUrl,
      recordFileUrl: callCenterConfig.recordFileUrl
    }
    sendWSPush(JSON.stringify(sendMsg))
  }

  async function cacheUser(data: Recordable) {
    console.log(callCenter.value, 'cacheUser')
    let currentUserInfo = userInfo
    if (!currentUserInfo.id) {
      // 线上出现了200ubndefined的情况，补救这种情况
      await useAccountStore?.()?.getUser?.()
      currentUserInfo = useAccountStore()?.userInfo
    }
    const { callCenterConfig, iccid, callNumberIn, callNumberOut } = callCenter.value
    cacheUserIdAndCustId({
      userId: `200${currentUserInfo.id}`,
      custId: data.customId,
      uniqueId: data.uniqueId,
      parentAppId: callCenterConfig.callCenterAppId,
      iccId: iccid || 0,
      agentId: callCenterConfig.callSeatId,
      callNumber:
        callCenter.value.callDirection === callDirection.in ? callNumberIn : callNumberOut,
      callType: callCenter.value.callType
    }).then(() => {
      const sendMsg = {
        cmd: 'setCallrecord',
        pid: callCenterConfig.callCenterAppId,
        callrecordUrl: callCenterConfig.callRecordUrl,
        recordFileUrl: callCenterConfig.recordFileUrl
      }
      sendWSPush(JSON.stringify(sendMsg))
    })
  }

  // 切卡
  // let changeNum = 0
  function changeSim() {
    const changeSimListCopy = cloneDeep(callCenter.value.changeSimList)
    if (changeSimListCopy.length === 0 || changeSimListCopy.length === changeNum.value) {
      //  没有可切换的卡
      rxkMessageBox('所有sim卡已达呼叫次数上限，请明天再拨打', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        changeNum.value = 0
      })
      return false
    }
    ElMessage.success('自动切卡中')
    sendWSPush(
      JSON.stringify({
        cmd: 'changeSim',
        value: changeSimListCopy[changeNum.value].index,
        status: 0
      })
    )
  }

  return {
    createCallCenterSocket,
    sendWSPush,
    setHidNumber,
    bindPhoneNumber,
    oncloseWS,
    getCallNumber,
    setRoundCallrecordUrl,
    setCallrecordUrl,
    changeSim
  }
}
